module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app-layout', [_c('v-bloc', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('v-section-header', [_vm._v("\n          Tarjouspyynnön tiedot\n        ")]), _vm._v(" "), _c('v-form-group-input', {
    attrs: {
      "name": "quoteName",
      "rules": "required"
    }
  }, [_vm._v("\n          Nimi\n        ")]), _vm._v(" "), _c('v-alert', [_vm._v("\n          Anna tarjouspyynnölle sellainen nimi että toimittajat huomaavat helposti mistä on tarjouspyynnössä kyse. \nNimen olisi olla hyvä myös helposti tunnistettavissa muista tarjouspyyntöjen nimistä. \n        ")]), _vm._v(" "), _c('v-form-group-input', {
    attrs: {
      "component": "textarea",
      "name": "description"
    }
  }, [_vm._v("\n          Kuvaus\n        ")]), _vm._v(" "), _c('v-alert', [_vm._v("\n          Anna tarjouspyynnölle lyhyt kuvaus tarjouspyynnön sisällöstä ja työn laajuudesta. \nMe esitämme tämän lyhyen kuvauksen toimittajalle sivuillamme. \n        ")]), _vm._v(" "), _c('v-section-header', [_vm._v("\n          Tarjouksien viimeinen jättöpäivä\n        ")]), _vm._v(" "), _c('v-form-group-input', {
    attrs: {
      "name": "quoteEndDate",
      "rules": "required",
      "type": "date",
      "contextualStyle": "medium-field"
    }
  }, [_vm._v("\n          Valitse päivämäärä\n      ")]), _vm._v(" "), _c('v-form-group-input', {
    attrs: {
      "name": "quoteEndTime",
      "rules": "required",
      "type": "time",
      "contextualStyle": "short-field"
    }
  }, [_vm._v("\n          Valitse kellonaika\n      ")]), _vm._v(" "), _c('v-nav-footer', {
    attrs: {
      "prevRoute": "bidders.index",
      "nextRoute": "inner-files.index",
      "routeParams": {
        projectId: _vm.$store.state.route.params.projectId
      }
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-4dc3a192"}!./src/app/pages/inner-basics/inner-basics.html
// module id = 478
// module chunks = 1